'use client';

import { Box } from '@mui/material';
import styled from '@emotion/styled';
import Image from 'next/image';
import { color, borderRadius, spacing } from '@/theme/tokens';
import { MDXProvider } from '@mdx-js/react';
import { usePathname } from 'next/navigation';
import { breakpoints } from '@/theme/tokens';
import { getMDXComponents } from '@/components/common/MDXComponents';

const Wrapper = styled(Box)`
    padding: ${spacing[16]};
    background-color: ${color.white[0]};
    border-radius: ${borderRadius[8]};
    display: flex;
    flex-direction: column;

    @media (min-width: ${breakpoints.sm}) {
        padding: ${spacing[24]};
    }

    @media (min-width: ${breakpoints.md}) {
        padding: ${spacing[32]};
    }
`;

const CompanyImage = styled(Box)`
    position: relative;
    width: 100%;
    aspect-ratio: 1992/996;
    overflow: hidden;
    margin: ${spacing[16]} 0;

    @media (min-width: ${breakpoints.sm}) {
        margin: ${spacing[24]} 0;
    }

    @media (min-width: ${breakpoints.md}) {
        margin: ${spacing[32]} 0;
    }
`;

const getCompanyImage = (pathname: string) => {
    if (pathname.includes('/company/news')) {
        return null;
    } else {
        return '/company/company-about-us.jpg';
    }
};

export default function CompanyContent({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    const companyImage = getCompanyImage(pathname);

    const h1Image = companyImage ? (
        <CompanyImage>
            <Image
                src={companyImage}
                alt="Company illustration"
                fill
                priority
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px"
                style={{
                    objectFit: 'cover',
                    objectPosition: '50% 50%',
                }}
            />
        </CompanyImage>
    ) : null;

    return (
        <Wrapper>
            <MDXProvider
                components={getMDXComponents({
                    customLink: true,
                    h1Image,
                    paragraphMargin: {
                        base: spacing[16],
                        sm: spacing[16],
                        md: spacing[16],
                    },
                    listMargin: {
                        base: spacing[16],
                        sm: spacing[20],
                        md: spacing[24],
                    },
                })}
            >
                {children}
            </MDXProvider>
        </Wrapper>
    );
}
